import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';
import { getToken } from './TokenStorage';

const TAX_URL = getBaseUrl('/tax/');

// Apuração de IR (ganho de capital) — JSON para a tela. environment default = production no backend.
export async function getCapitalGains(year, environment) {
    const params = new URLSearchParams();
    if (year) params.append('year', year);
    if (environment) params.append('environment', environment);
    return await appRequest.doGetRequest(`${TAX_URL}capitalGains?${params.toString()}`);
}

// Baixa um CSV (operations | monthly | positions | in1888) como arquivo. fetch direto p/ blob.
export async function downloadTaxCsv(year, type, environment) {
    const params = new URLSearchParams();
    if (year) params.append('year', year);
    if (type) params.append('type', type);
    if (environment) params.append('environment', environment);

    const token = getToken();
    const response = await fetch(`${TAX_URL}capitalGains/export?${params.toString()}`, {
        method: 'GET',
        headers: token ? { authorization: token } : {}
    });
    if (!response.ok) throw new Error(`Falha ao gerar CSV (HTTP ${response.status})`);

    const blob = await response.blob();
    const cd = response.headers.get('Content-Disposition') || '';
    const match = cd.match(/filename="([^"]+)"/);
    const filename = match ? match[1] : `hydra-ir-${year}-${type}.csv`;

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
